import React from 'react'
import { Link } from 'react-scroll'
import Typical from 'react-typical'
import headImg from '../../images/header.png'
import './Header.css'

const Header = () => {
  return (
    <div
      data-aos="fade-down"
      data-aos-easing="ease-in-sine"
      data-aos-duration="1000"
      className="row headerMain d-flex  align-items-center"
    >
      <div
        data-aos="fade-down-right"
        data-aos-easing="linear"
        data-aos-duration="1400"
        className="col-md-6 col-sm-12"
        style={{ color: '#006ADC' }}
      >
        <h5>Hello, I am</h5>
        <h1 style={{ color: ' #ffff' }}>Md. Irtiza Hossain</h1>
        <h4>
          I{' '}
          <span style={{ color: '#e13697' }}>
            <Typical
              loop={Infinity}
              wrapper="b"
              steps={['build', 1500, 'create', 500, 'maintain', 500]}
            />
          </span>{' '}
          website based projects.
        </h4>
        <Link to="contact" smooth={true} duration={800}>
          <button class="btn-2">Get in touch</button>
        </Link>
      </div>

      <div className="col-md-6 col-sm-12 md sm ">
        <img
          data-aos="fade-down-left"
          data-aos-easing="linear"
          data-aos-duration="1400"
          src={headImg}
          alt="headImg"
          className="fluid headImg"
        />
      </div>
    </div>
  )
}

export default Header
